// extracted by mini-css-extract-plugin
export const wrapper = "BoxList-module--wrapper--3HTlV";
export const list = "BoxList-module--list--2-wx1";
export const outline = "BoxList-module--outline--mdnfB";